<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title> Dados do registro </v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-6">
              <v-text-field
                label="Cliente"
                v-model="current.clientName"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-6">
              <v-text-field
                label="Plano"
                v-model="current.planName"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-9">
              <v-text-field
                label="Endereco"
                v-model="current.address"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Cidade"
                v-model="current.city"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <v-text-field
                label="Instalacao"
                :value="current.setup | formatDate"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Valor"
                v-model="current.payValue"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-text-field
                label="Vencimento"
                v-model="current.payDay"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-3">
              <v-chip :color="colorContractStatus(current.status)">{{current.status | formatContractStatus}}</v-chip>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from '../../api/index.js';
export default {
  data: function () {
    return {
      current: null,
    };
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/contract/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar o registro!");
          console.log(error);
        });
    },
    colorContractStatus: function(status){
      var color = "default";
      if(status==0){
        color = "success";
      } else if (status == 1) {
        color = "warning";
      } else if (status == 2) {
        color = "info";
      } else if (status == 3) {
        color = "error";
      } else if (status == 4) {
        color = "secondary";
      }
      return color;
    }
  },
  filters: {
    formatContractStatus: function (status) {
      var text = "Desconhecido";
      if (status==0){
        text = "Habilitado";
      }else if (status==1){
        text = "Bloqueio administrador";
      }else if(status==2){
        text = "Bloqueio cliente";
      }else if(status==3){
        text = "Bloqueio financeiro";
      }else if(status==4){
        text = "Cancelado";
      }
      return text;
    }
  }
};
</script>